module.exports = __webpack_public_path__ + "img/small_logo_yellow.046ef05c.svg";